module.exports = __webpack_public_path__ + "img/search.9aef2836.svg";